import { StyleGroupDefinition, StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [
	{
		dn: 'File Selector Font',
		n: 'fileSelectorFont',
		dv: '<primaryFont>',
		cp: 'font',
		sel: '.comp.compFileSelector',
	},

	{
		gn: 'Color of the upload image',
		dn: 'Primary Upload Image Color',
		n: 'primaryUploadImageColor',
		dv: '<fontColorThree>',
		cp: 'color',
		sel: '.comp.compFileSelector._primary',
		np: true,
	},
	{
		gn: 'Color of the upload image',
		dn: 'Secondary Upload Image Color',
		n: 'secondaryUploadImageColor',
		dv: '<fontColorFour>',
		cp: 'color',
		sel: '.comp.compFileSelector._secondary',
		np: true,
	},
	{
		gn: 'Color of the upload image',
		dn: 'Tertiary Upload Image Color',
		n: 'tertiaryUploadImageColor',
		dv: '<fontColorFive>',
		cp: 'color',
		sel: '.comp.compFileSelector._tertiary',
		np: true,
	},
	{
		gn: 'Color of the upload image',
		dn: 'Quaternary Upload Image Color',
		n: 'quaternaryUploadImageColor',
		dv: '<fontColorNine>',
		cp: 'color',
		sel: '.comp.compFileSelector._quaternary',
		np: true,
	},
	{
		gn: 'Color of the upload image',
		dn: 'Quinary Upload Image Color',
		n: 'quinaryUploadImageColor',
		dv: '<fontColorSeven>',
		cp: 'color',
		sel: '.comp.compFileSelector._quinary',
		np: true,
	},
	{
		gn: 'Background Color of the Progress Bar',
		dn: 'Progress Bar Background Color',
		n: 'progressBarBackgroundColor',
		cp: 'backgroundColor',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Border',
		dn: 'Border of the Progress Bar',
		n: 'progressBarBorder',
		cp: 'border',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Border Radius',
		dn: 'Border Radius of the Progress Bar',
		n: 'progressBarBorderRadius',
		cp: 'borderRadius',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Minimum Width',
		dn: 'Minimum Width of the Progress Bar',
		n: 'progressBarMinWidth',
		cp: 'minWidth',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Height',
		dn: 'Height of the Progress Bar',
		n: 'progressBarHeight',
		cp: 'height',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Margin',
		dn: 'Margin of the Progress Bar',
		n: 'progressBarMargin',
		cp: 'margin',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Padding',
		dn: 'Padding of the Progress Bar',
		n: 'progressBarPadding',
		cp: 'padding',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Box Shadow',
		dn: 'Box Shadow of the Progress Bar',
		n: 'progressBarBoxShadow',
		cp: 'boxShadow',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Box Shadow',
		dn: 'Box Shadow of the Progress Bar',
		n: 'progressBarBoxShadow',
		cp: 'boxShadow',
		sel: '.comp.compFileSelector._progressBarfileUpload<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar upload button',
		dn: 'Upload Button of the Progress Bar',
		n: 'progressBarUploadButton',
		cp: 'border',
		sel: '.comp.compFileSelector._progressBarUploadButton<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Upload Button',
		dn: 'Border Radius of the Upload Button',
		n: 'progressBarUploadButtonBorderRadius',
		cp: 'borderRadius',
		dv: '4px',
		sel: '.comp.compFileSelector._progressBarUploadButton<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Upload Button',
		dn: 'Background Color of the Upload Button',
		n: 'progressBarUploadButtonBgColor',
		cp: 'backgroundColor',
		dv: '#FFFFFF',
		sel: '.comp.compFileSelector._progressBarUploadButton<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Upload Button',
		dn: 'Padding of the Upload Button',
		n: 'progressBarUploadButtonPadding',
		cp: 'padding',
		dv: '0px 8px',
		sel: '.comp.compFileSelector._progressBarUploadButton<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Upload Button',
		dn: 'Height of the Upload Button',
		n: 'progressBarUploadButtonHeight',
		cp: 'height',
		dv: '40px',
		sel: '.comp.compFileSelector._progressBarUploadButton<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Upload Button',
		dn: 'Font of the Upload Button',
		n: 'progressBarUploadButtonFont',
		cp: 'font',
		dv: '600 14px/14px Inter',
		sel: '.comp.compFileSelector._progressBarUploadButton<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Upload Button',
		dn: 'Color of the Upload Button Text',
		n: 'progressBarUploadButtonColor',
		cp: 'color',
		dv: '#364359',
		sel: '.comp.compFileSelector._progressBarUploadButton<colorScheme>',
		np: true,
	},
	{
		gn: 'Progress Bar Upload Button',
		dn: 'Margin of the Upload Button',
		n: 'progressBarUploadButtonMargin',
		cp: 'margin',
		dv: '0px',
		sel: '.comp.compFileSelector._progressBarUploadButton<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Placeholder Text',
		dn: 'Placeholder Text of the File Selector',
		n: 'fileSelectorPlaceholderText',
		cp: 'font',
		sel: '.comp.compFileSelector._fileUploadPlaceholderText<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Placeholder Text Color',
		dn: 'Placeholder Text Color of the File Selector',
		n: 'fileSelectorPlaceholderTextColor',
		cp: 'color',
		sel: '.comp.compFileSelector._fileUploadPlaceholderText<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Outer Container Upload Status',
		dn: 'Outer Container Upload Status of the File Selector',
		n: 'fileSelectorOuterContainerUploadStatus',
		cp: 'height',
		sel: '.comp.compFileSelector._outerContainerUploadStatus<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Outer Container Upload Status',
		dn: 'Outer Container Upload Status Width of the File Selector',
		n: 'fileSelectorOuterContainerUploadStatusWidth',
		cp: 'width',

		sel: '.comp.compFileSelector._outerContainerUploadStatus<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Inner Progress Bar Container',
		dn: 'Inner Progress Bar Container Height of the File Selector',
		n: 'fileSelectorInnerProgressBarContainerHeight',
		cp: 'height',
		sel: '.comp.compFileSelector_InnerProgressBarContainer<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Inner Progress Bar Container',
		dn: 'Inner Progress Bar Container padding of the File Selector',
		n: 'fileSelectorInnerProgressBarContainerPadding',
		cp: 'padding',
		sel: '.comp.compFileSelector_InnerProgressBarContainer<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Outer Container Upload Status',
		dn: 'Outer Container Upload Status Border Radius of the File Selector',
		n: 'fileSelectorOuterContainerUploadStatusBorderRadius',
		cp: 'borderRadius',
		sel: '.comp.compFileSelector._outerContainerUploadStatus<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Outer Container Upload Status',
		dn: 'Outer Container Upload Status Margin of the File Selector',
		n: 'fileSelectorOuterContainerUploadStatusMargin',
		cp: 'margin',

		sel: '.comp.compFileSelector._outerContainerUploadStatus<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Inner Container Upload Status',
		dn: 'Inner Container Upload Status Height of the File Selector',
		n: 'fileSelectorInnerContainerUploadStatusHeight',
		cp: 'height',

		sel: '.comp.compFileSelector._InnerContainerUploadStatus<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Inner Container Upload Status',
		dn: 'Inner Container Upload Status Width of the File Selector',
		n: 'fileSelectorInnerContainerUploadStatusWidth',
		cp: 'width',

		sel: '.comp.compFileSelector._InnerContainerUploadStatus<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Inner Container Upload Status',
		dn: 'Inner Container Upload Status Background Color of the File Selector',
		n: 'fileSelectorInnerContainerUploadStatusBgColor',
		cp: 'backgroundColor',

		sel: '.comp.compFileSelector._InnerContainerUploadStatus<colorScheme>',
		np: true,
	},
	{
		gn: 'File Selector Inner Container Upload Status',
		dn: 'Inner Container Upload Status Border Radius of the File Selector',
		n: 'fileSelectorInnerContainerUploadStatusBorderRadius',
		cp: 'borderRadius',

		sel: '.comp.compFileSelector._InnerContainerUploadStatus<colorScheme>',
		np: true,
	},
	{
		gn: 'Image Preview Placeholder',
		dn: 'Background Color of Preview Placeholder',
		n: 'imagePreviewPlaceholderBgColor',
		cp: 'backgroundColor',

		sel: '.comp.compFileSelector._ImagePreviewPlaceholder<colorScheme>',
		np: true,
	},
	{
		gn: 'Image Preview Placeholder',
		dn: 'Border Radius of Preview Placeholder',
		n: 'imagePreviewPlaceholderBorderRadius',
		cp: 'borderRadius',

		sel: '.comp.compFileSelector._ImagePreviewPlaceholder<colorScheme>',
		np: true,
	},
	{
		gn: 'Image Preview Placeholder',
		dn: 'Width of Preview Placeholder',
		n: 'imagePreviewPlaceholderWidth',
		cp: 'width',

		sel: '.comp.compFileSelector._ImagePreviewPlaceholder<colorScheme>',
		np: true,
	},
	{
		gn: 'Image Preview Placeholder',
		dn: 'Height of Preview Placeholder',
		n: 'imagePreviewPlaceholderHeight',
		cp: 'height',
		sel: '.comp.compFileSelector._ImagePreviewPlaceholder<colorScheme>',
		np: true,
	},
	{
		gn: 'Image Preview Placeholder',
		dn: 'Margin of Preview Placeholder',
		n: 'imagePreviewPlaceholderMargin',
		cp: 'margin',

		sel: '.comp.compFileSelector._ImagePreviewPlaceholder<colorScheme>',
		np: true,
	},

	{
		gn: 'Preview Image Container',
		dn: 'Width of Preview Container and Image',
		n: 'previewContainerWidth',
		cp: 'width',
		sel: '.comp.compFileSelector._previewImageContainer<colorScheme>, .comp.compFileSelector._previewImage<colorScheme>',
		np: true,
	},
	{
		gn: 'Preview Image Container',
		dn: 'Height of Preview Container and Image',
		n: 'previewContainerHeight',
		cp: 'height',
		sel: '.comp.compFileSelector._previewImageContainer<colorScheme>, .comp.compFileSelector._previewImage<colorScheme>',
		np: true,
	},
	{
		gn: 'Preview Image Container',
		dn: 'Margin of Preview Container',
		n: 'previewContainerMargin',
		cp: 'margin',

		sel: '.comp.compFileSelector._previewImageContainer<colorScheme>',
		np: true,
	},
	{
    gn: 'Progress Bar File Upload Text',
    dn: 'Font of File Upload Text',
    n: 'progressBarFileUploadTextFont',
    cp: 'font',
    sel: '.comp.compFileSelector._progressBarFileUploadText<colorScheme>',
    np: true,
},
{
    gn: 'Progress Bar File Upload Text',
    dn: 'Color of File Upload Text',
    n: 'progressBarFileUploadTextColor',
    cp: 'color',
    sel: '.comp.compFileSelector._progressBarFileUploadText<colorScheme>',
    np: true,
},

{
    gn: 'Progress Bar File Upload Text',
    dn: 'Width of File Upload Text',
    n: 'progressBarFileUploadTextWidth',
    cp: 'width',
    sel: '.comp.compFileSelector._progressBarFileUploadText<colorScheme>',
    np: true,
},
{
    gn: 'Progress Bar upload status',
    dn: 'Background Color of the Progress Bar uploading status',
    n: 'progressBarFileUploadUploadingStatusBgColor',
    cp: 'backgroundColor',
    sel: '.comp.compFileSelector._uploadingBackgroundColor<colorScheme>',
    np: true,
},
{
    gn: 'Progress Bar Upload status',
	dn: 'Background Color of the Progress Bar done status',
    n: 'progressBarFileUploadDoneStatusBgColor',
    cp: 'backgroundColor',
    sel: '.comp.compFileSelector._doneBackgroundColor<colorScheme>',
    np: true,
},
{
    gn: 'Download Icon Color',
	dn: 'Color of the Download Icon',
    n: 'downloadIconColor',
    cp: 'stroke',
    sel: '.comp.compFileSelector._downloadIcon<colorScheme>',
    np: true,
},
{
    gn: 'Delete Icon Color',
	dn: 'Color of the Delete Icon',
    n: 'deleteIconColor',
    cp: 'stroke',
    sel: '.comp.compFileSelector._deleteIcon<colorScheme>',
    np: true,
},
{
    gn: 'Progress Bar File Upload Label',
    dn: 'Progress Bar File Upload Label Text',
    n: 'progressBarFileUploadLabelTextFont',
    cp: 'font',
    sel: '.comp.compFileSelector._label',
    np: true,
},
{
    gn: 'Progress Bar File Upload Label',
    dn: 'Progress Bar File Upload Label color',
    n: 'progressBarFileUploadLabelTextColor',
    cp: 'color',
    sel: '.comp.compFileSelector._label',
    np: true,
},
{
    gn: 'Progress Bar File Upload Label',
    dn: 'Progress Bar File Upload Label margin',
    n: 'progressBarFileUploadLabelTextMargin',
    cp: 'margin',
    sel: '.comp.compFileSelector._label',
    np: true,
}

];

export const styleDefaults = new Map<string, string>(
	styleProperties
		.filter(e => !!e.dv)
		.map(({ n: name, dv: defaultValue }) => [name, defaultValue!]),
);
